import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/NavBar/navBar.js";
import Footer from "./components/Footer/Footer.js";
import TermsPage from "./components/Terms/TermsPage.js";
import HomePage from "./pages/Home/HomePage.js";
import PrivacyPolicy from "./components/Privacy/PrivacyPage.js";
import EventDetailsPage from "./components/EventPage/EventDetailsPage.js";
import UserProfilePage from "./components/UserProfile/UserProfile.js";
import DownloadAppPage from "./pages/Tester/DownloadAppPage.js";
import ChatRoomPage from "./components/ChatRoom/ChatRoom.js";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

function App() {
  return (
    <div className="app-main-layout">
      <Router>
        <ScrollToTop />
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" exact element={<HomePage />} />

            <Route path="/download" element={<DownloadAppPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* handles deep linking */}
            <Route path="/events/:eventId" element={<EventDetailsPage />} />
            <Route path="/userprofile/:userId" element={<UserProfilePage />} />
            <Route path="/messages/:chatRoomId" element={<ChatRoomPage />} />
            <Route
              path="/events/:eventId/invitations/:invitationId/e-ticket"
              element={<EventDetailsPage />}
            />
            <Route
              path="/events/:eventId/locations/:locationId/self-check-in"
              element={<EventDetailsPage />}
            />
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
